import cc from 'classcat';
import { useRef, useCallback, useEffect } from 'react';
import { containerCls, lineCls } from './Line.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const Line = ({
  sheetRef,
  pageId,
  pageAspectRatio,
  zIndex,
  item,
  isCloned,
  isSelected,
  onSelect,
  onDragStart,
  Before,
  Line,
  After
}) => {
  const containerRef = useRef(null);
  const handleSelect = useCallback(evt => {
    if (onSelect !== undefined) {
      onSelect(evt, item);
    }
  }, [item, onSelect]);
  useEffect(() => {
    const node = containerRef.current;
    if (node === null) {
      return;
    }
    node.addEventListener("focusin", handleSelect, {
      passive: false
    });
    node.addEventListener("mousedown", handleSelect, {
      passive: false
    });
    node.addEventListener("touchstart", handleSelect, {
      passive: false
    });
    return () => {
      node.removeEventListener("focusin", handleSelect);
      node.removeEventListener("mousedown", handleSelect);
      node.removeEventListener("touchstart", handleSelect);
    };
  }, [item, handleSelect]);

  // calculate line aspect ratio in order to extend it all the way to the fill
  // the container, using pythagoren theorem
  const itemWidth = item.size.width;
  const itemHeight = item.size.height * pageAspectRatio;
  const lineLength = Math.sqrt(100 ** 2 + (itemHeight / itemWidth * 100) ** 2);

  // calculate the angle of the line, in order to ensure that the line renders
  // from one corner to the next
  const angle = Math.atan2(itemHeight, itemWidth) * (item.reverseLineDirection ? -1 : 1);
  const handlePointerDragStart = evt => {
    if (!item.settings.cloneable && !item.settings.movable) {
      return;
    }
    onDragStart?.(evt, item);
  };
  const handleKeyDown = evt => {
    if ((evt.key === " " || evt.key === "Enter") && !document.body.classList.contains("isDragging")) {
      onDragStart?.(evt, item);
    }
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    jsxs("div", {
      ref: containerRef,
      onMouseDown: handlePointerDragStart,
      onTouchStart: handlePointerDragStart,
      onKeyDown: handleKeyDown,
      "data-drag-target": true,
      "data-id": item.id,
      className: containerCls,
      style: {
        zIndex,
        left: `${(item.position.x * 100).toString()}%`,
        top: `${(item.position.y * 100).toString()}%`,
        width: `${(item.size.width * 100).toString()}%`,
        height: `${(item.size.height * 100).toString()}%`
      },
      children: [Before !== undefined && /*#__PURE__*/jsx(Before, {
        sheetRef: sheetRef,
        pageId: pageId,
        pageAspectRatio: pageAspectRatio,
        isCloned: isCloned,
        isSelected: isSelected,
        item: item
      }), /*#__PURE__*/jsx("div", {
        className: cc([lineCls, {
          reversed: item.reverseLineDirection
        }]),
        style: {
          width: `calc(${lineLength.toString()}% - ${(item.style.stroke.width / 2).toString()}px)`,
          height: `${item.style.stroke.width.toString()}px`,
          backgroundColor: item.style.stroke.color,
          transform: `rotate(${angle.toString()}rad)`,
          transformOrigin: `${(item.style.stroke.width / 2).toString()}px ${(item.style.stroke.width / 2).toString()}px`
        }
      }), Line !== undefined && /*#__PURE__*/jsx(Line, {
        sheetRef: sheetRef,
        pageId: pageId,
        pageAspectRatio: pageAspectRatio,
        isCloned: isCloned,
        isSelected: isSelected,
        item: item
      }), After !== undefined && /*#__PURE__*/jsx(After, {
        sheetRef: sheetRef,
        pageId: pageId,
        pageAspectRatio: pageAspectRatio,
        isCloned: isCloned,
        isSelected: isSelected,
        item: item,
        onDragStart: onDragStart
      })]
    })
  );
};

export { Line };
//# sourceMappingURL=Line.js.map
